module.exports = __webpack_public_path__ + "img/coffin.f9c2c61b.svg";